import { render, staticRenderFns } from "./Layout2.vue?vue&type=template&id=5515fdd2&scoped=true"
import script from "./Layout2.vue?vue&type=script&lang=js"
export * from "./Layout2.vue?vue&type=script&lang=js"
import style0 from "./Layout2.vue?vue&type=style&index=0&id=5515fdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515fdd2",
  null
  
)

export default component.exports